// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DribbbleCircleFilledSvg from "@ant-design/icons-svg/es/asn/DribbbleCircleFilled";
import AntdIcon from '../components/AntdIcon';

var DribbbleCircleFilled = function DribbbleCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: DribbbleCircleFilledSvg
  }));
};

DribbbleCircleFilled.displayName = 'DribbbleCircleFilled';
export default React.forwardRef(DribbbleCircleFilled);